import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate, useLocation, matchPath } from "react-router-dom";
import './NavbarMobile.css';
import { HiMenu } from "react-icons/hi";
import { IoMdSettings } from "react-icons/io";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { useCustomContext } from "../../UIElements/CustomComponents/CustomComponents";
import { FaFolder, FaHome } from "react-icons/fa";
import { FaUserGroup } from "react-icons/fa6";
import { IoMdNotifications } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import { CgDetailsMore } from "react-icons/cg";
import { insertLog } from "../Logs/InsertLog";
import { LuLogs } from "react-icons/lu";

const NavbarMobileUI = ({ username, onSignout }) => {
  const [isIconsOnly, setIsIconsOnly] = useState(true)

  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert, stopHudRotation, hud } = useCustomContext();
  const folderMatch = matchPath('/details', location.pathname);
  const accessLevel = parseInt(localStorage.getItem('accessLevel'), 10);
  const UserStatus = localStorage.getItem("UserStatus");
  const useremail = localStorage.getItem("email");
  const userName = useremail?.split('@')[0];
  // Check if current path matches the folder route



  const handleMenu = (e) => {
    setIsIconsOnly((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.querySelector('.mbl-sidebar');
      if (sidebar && !sidebar.contains(event.target)) {
        setIsIconsOnly(true);
      }
    };

    if (isIconsOnly === false) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isIconsOnly]);


  const closeSidebar = () => {
    setIsIconsOnly(true);
  };

  const Logout = () => {
    // Keys to keep
    const keysToKeep = ['rememberMe', 'rememberedEmail', 'rememberedPassword'];

    showAlert('Are you sure you want to logout?', [
      {
        label: 'Yes',
        onClick: async () => {
          Object.keys(localStorage).forEach((key) => {
            if (!keysToKeep.includes(key)) {
              localStorage.removeItem(key);
            }
          });

          try {
            await insertLog(
                `${userName} successfully logged out`,
                0,
                useremail,
                hud,
                stopHudRotation,
            );

            onSignout();
            navigate('/');   // Redirect after signout
          } catch (error) {
            console.error('Failed to insert logout log:', error);
            showAlert('Logout log failed. Still signing out for safety.', [
              { label: 'Ok', color: 'var(--buttonColor)' }
            ]);
            onSignout();
            navigate('/');
          }
        },
        color: 'var(--buttonColor)', // Set button color
      },
      {
        label: 'No',
        onClick: () => {
          // console.log('User cancelled logout');
        },
        color: 'gray', // Set button color
      }
    ]);

  };
  return (
    <div className={`mbl-sidebar ${isIconsOnly ? 'icons-only' : ''}`} >

      <div className='mbl-headingandhamburger'>
        {!isIconsOnly && <span className='mbl-organizationname'>Referral Manager</span>}
        <span className='mbl-hamburger' onClick={handleMenu}>
          {isIconsOnly ? <HiMenu size={24} className='himenu-mbl' /> : <RxCross2 size={20} color='white' />}
        </span>
        {/* <div className="position-fixed" style={{ top: 0, right: 0, padding: '10px' }}>
          <button
            className="btn  d-flex align-items-center"
            onClick={Logout}
            style={{ cursor: 'pointer' }}
          >
            <RiLogoutCircleRLine style={{ fontSize: '24px' }} />
            <span className="ms-2">Logout</span>
          </button>
        </div> */}
      </div>

      <ul className='navbar-list'>
        <li className='navbar-list-item'>
          <NavLink to="/Referrals" className="menu-mbl" onClick={closeSidebar}>
            <FaHome className="icon" size={17} /> {!isIconsOnly && <span className='menu-mbl-text'>Referrals</span>}
          </NavLink>
        </li>

        {folderMatch && (
          <li className='navbar-list-item'>
            <NavLink
              to="/details"
              className="menu-mbl"
              onClick={closeSidebar}
              style={{ marginLeft: '20px' }}
            >
              <CgDetailsMore className="icon" size={17} /> {!isIconsOnly && <span className='menu-text'>Details</span>}
            </NavLink>
          </li>
        )}
        {accessLevel == 3 &&
          (
            <li className='navbar-list-item'>
              <NavLink
                to="/Users"
                className="menu-mbl" onClick={closeSidebar}>
                <FaUserGroup className="icon" />{!isIconsOnly && <span className='menu-mbl-text'>Users</span>}
              </NavLink>
            </li>
          )}

        {(accessLevel === 2 || accessLevel === 3) && (
          <li className='navbar-list-item'>
            <NavLink
              to="/Logs"
              className="menu-mbl" onClick={closeSidebar} >
              <LuLogs className="icon" />{!isIconsOnly && <span className='menu-text'>Logs</span>}
            </NavLink>
          </li>
        )}



        <li className='navbar-list-item'>

          {(UserStatus !== 'EXTERNAL_PROVIDER') &&
            <NavLink
              className="menu-mbl" onClick={closeSidebar}
              to="/Settings"
            >
              <IoMdSettings className="icon" />{!isIconsOnly && <span className='menu-mbl-text'>Settings</span>}
            </NavLink>

          }

        </li>
        <li className='navbar-list-item'>
          <NavLink
            to="#"
            className="menu-mbl logout"
            isActive={() => false}
            onClick={Logout}
          >
            <RiLogoutCircleRLine className="icon" />
            {!isIconsOnly && <span className='menu-mbl-text'>Logout</span>}
          </NavLink>
        </li>
      </ul>
      {/* </div> */}
      {/* </header> */}
      {/* <div className={`display-text ${isIconsOnly ? "icons-only" : ""}`}>
        <div className="navbar-text1 ml-auto">

          <div className="dropdownview" ref={dropdownRef}>
            <div className="position-fixed" style={{ top: 0, right: 0, padding: '10px' }}>
              <button
                className="btn  d-flex align-items-center"
                onClick={Logout}
                style={{ cursor: 'pointer' }}
              >
                <RiLogoutCircleRLine style={{ fontSize: '24px' }} />
                <span className="ms-2">Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div> */}

    </div >
  );
}

export default NavbarMobileUI;
